// Product Display Custom Cursor Script
(function() {
    'use strict';
    
    // Check if device supports hover
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      return;
    }
  
    // Global cursor manager to ensure only one cursor exists
    class ProductDisplayCursorManager {
      constructor() {
        this.cursor = null;
        this.currentX = 0;
        this.currentY = 0;
        this.targetX = 0;
        this.targetY = 0;
        this.ease = 0.15;
        this.animationFrame = null;
        this.isActive = false;
        this.initialized = false;
        this.sections = [];
        
        this.init();
      }
  
      init() {
        this.createCursor();
        this.bindGlobalEvents();
        this.animate(); // 始终运行，保证悬浮时坐标已就位
      }
  
      createCursor() {
        // Check if cursor already exists
        if (document.querySelector('.mt-pd-cursor')) {
          this.cursor = document.querySelector('.mt-pd-cursor');
          return;
        }
        
        this.cursor = document.createElement('div');
        this.cursor.className = 'mt-pd-cursor';
        
        this.cursor.innerHTML = `
          <svg class="mt-pd-cursor__icon-circle" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="30" cy="30" r="29" stroke="white" stroke-width="2"/>
          </svg>
          <svg class="mt-pd-cursor__icon-left" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="30" cy="30" r="29" stroke="white" stroke-width="1"/>
            <path d="M31.1396 24.1931C30.9701 23.9752 30.6564 23.9358 30.4385 24.1052L21.4385 31.1052C21.3167 31.2 21.2451 31.3455 21.2451 31.4998C21.2451 31.654 21.3167 31.7996 21.4385 31.8943L30.4385 38.8943C30.6564 39.0637 30.9701 39.0243 31.1396 38.8064C31.3091 38.5884 31.2697 38.2747 31.0518 38.1052L23.2021 31.9998H39.5C39.776 31.9996 40 31.7758 40 31.4998C39.9999 31.2237 39.776 30.9999 39.5 30.9998H23.2021L31.0518 24.8943C31.2697 24.7248 31.3091 24.4111 31.1396 24.1931Z" fill="#F5F2EE"/>
          </svg>
          <svg class="mt-pd-cursor__icon-right" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="30" cy="30" r="29" stroke="white" stroke-width="1"/>
           <path fill-rule="evenodd" clip-rule="evenodd" d="M30.8604 24.1933C31.0299 23.9754 31.3436 23.936 31.5615 24.1055L40.5615 31.1055C40.6832 31.2002 40.7549 31.3457 40.7549 31.5C40.7548 31.6542 40.6832 31.7998 40.5615 31.8945L31.5615 38.8945C31.3436 39.0638 31.0298 39.0244 30.8604 38.8066C30.691 38.5887 30.7304 38.275 30.9482 38.1055L38.7979 32H22.5C22.224 31.9999 22.0001 31.776 22 31.5C22 31.2239 22.224 31.0001 22.5 31H38.7979L30.9482 24.8945C30.7304 24.7251 30.6911 24.4113 30.8604 24.1933Z" fill="#F5F2EE"/>
          </svg>
          <svg class="mt-pd-cursor__icon-drag" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="30" cy="30" r="29" stroke="white" stroke-width="1"/>
            <g transform="translate(13.5 25.5)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M26.5791 0.192933C26.7485 -0.0248242 27.0623 -0.0640962 27.2803 0.105043L32.0508 3.815C32.1724 3.90961 32.2439 4.05547 32.2441 4.20953C32.2441 4.36377 32.1725 4.50934 32.0508 4.60407L27.2803 8.315C27.0623 8.48424 26.7486 8.44491 26.5791 8.22711C26.4098 8.00915 26.4491 7.69442 26.667 7.52496L30.2852 4.71051H19.6221C19.3461 4.71036 19.1222 4.48645 19.1221 4.21051C19.1221 3.93446 19.3461 3.71066 19.6221 3.71051H30.2881L26.667 0.894105C26.4493 0.724554 26.4098 0.410808 26.5791 0.192933Z" fill="#F5F2EE"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.66504 0.193102C5.49554 -0.0248264 5.18184 -0.064202 4.96387 0.105212L0.193359 3.81517C0.0716896 3.90984 9.53674e-05 4.05555 0 4.2097C0.000127792 4.3638 0.0717449 4.50959 0.193359 4.60424L4.96387 8.31517C5.18174 8.48407 5.49563 8.44483 5.66504 8.22728C5.83449 8.00942 5.79483 7.69473 5.57715 7.52513L1.95703 4.7097H12.6221C12.8981 4.70956 13.1221 4.48575 13.1221 4.2097C13.1221 3.93365 12.8981 3.70985 12.6221 3.7097H1.95703L5.57715 0.894274C5.79496 0.724867 5.83413 0.411056 5.66504 0.193102Z" fill="#F5F2EE"/>
            </g>
          </svg>
          <svg class="mt-pd-cursor__icon-up" width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M56.8346 31.0013C56.8346 45.2687 45.2687 56.8346 31.0013 56.8346C16.7339 56.8346 5.16797 45.2687 5.16797 31.0013C5.16797 16.7339 16.7339 5.16797 31.0013 5.16797C45.2687 5.16797 56.8346 16.7339 56.8346 31.0013Z" stroke="#fff" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M37.8069 31.1396C38.0248 30.9701 38.0642 30.6564 37.8948 30.4385L30.8948 21.4385C30.8001 21.3167 30.6545 21.2451 30.5003 21.2451C30.346 21.2451 30.2005 21.3167 30.1057 21.4385L23.1057 30.4385C22.9363 30.6564 22.9757 30.9701 23.1936 31.1396C23.4116 31.3091 23.7253 31.2697 23.8948 31.0518L30.0003 23.2021V39.5C30.0004 39.776 30.2242 40 30.5003 40C30.7763 39.9999 31.0001 39.776 31.0003 39.5V23.2021L37.1057 31.0518C37.2752 31.2697 37.5889 31.3091 37.8069 31.1396Z" fill="#fff"/>
</svg>
<svg class="mt-pd-cursor__icon-down" width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M56.8346 31.0013C56.8346 45.2687 45.2687 56.8346 31.0013 56.8346C16.7339 56.8346 5.16797 45.2687 5.16797 31.0013C5.16797 16.7339 16.7339 5.16797 31.0013 5.16797C45.2687 5.16797 56.8346 16.7339 56.8346 31.0013Z" stroke="#fff" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M24.1931 30.8604C23.9752 31.0299 23.9358 31.3436 24.1052 31.5615L31.1052 40.5615C31.1999 40.6833 31.3455 40.7549 31.4997 40.7549C31.654 40.7549 31.7995 40.6833 31.8943 40.5615L38.8943 31.5615C39.0637 31.3436 39.0243 31.0299 38.8064 30.8604C38.5884 30.6909 38.2747 30.7303 38.1052 30.9482L31.9997 38.7979V22.5C31.9996 22.224 31.7758 22 31.4997 22C31.2237 22.0001 30.9999 22.224 30.9997 22.5V38.7979L24.8943 30.9482C24.7248 30.7303 24.4111 30.6909 24.1931 30.8604Z" fill="#fff"/>
</svg>

<svg class="mt-pd-cursor__icon-close" width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M30.9998 56.8334C45.2672 56.8334 56.8332 45.2674 56.8332 31.0001C56.8332 16.7327 45.2672 5.16675 30.9998 5.16675C16.7325 5.16675 5.1665 16.7327 5.1665 31.0001C5.1665 45.2674 16.7325 56.8334 30.9998 56.8334Z" stroke="white" stroke-linejoin="round"/>
<path d="M38.3064 23.6934L23.6929 38.3069" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M23.6934 23.6934L38.3069 38.3069" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

        `;
        
        document.body.appendChild(this.cursor);
      }
  
      bindGlobalEvents() {
        // Mouse move
        document.addEventListener('mousemove', (e) => this.updateCursorPosition(e));
      }
  
      registerSection(section) {
        if (this.sections.includes(section)) {
          return; // Already registered
        }
        
        this.sections.push(section);
        
        // Product cards
        const productCards = section.querySelectorAll('.mt-product-card__info');
        productCards.forEach(card => {
          card.addEventListener('mouseenter', () => this.showCursor('circle'));
          card.addEventListener('mouseleave', () => this.hideCursor());
        });
      }
  
      /**
       * Register navigation buttons across different components:
       * - Product display nav buttons
       * - Womo banner nav buttons
       * - Womo category nav buttons
       */
      registerNavButtons(root) {
        const scope = root || document;
  
        const bindOnce = (el, type) => {
          if (!el || el.dataset.mtCursorBound === 'true') return;
          el.dataset.mtCursorBound = 'true';
  
          const cursorType = type || 'circle';
          el.addEventListener('mouseenter', () => {
            // 禁用状态（button[disabled] 或 aria-disabled="true"）不显示自定义光标
            const isDisabled =
              el.disabled === true ||
              el.getAttribute('aria-disabled') === 'true' ||
              el.matches('.mt-womo-category__nav-btn:disabled');
            if (isDisabled) return;
            this.showCursor(cursorType);
          });
          el.addEventListener('mouseleave', () => this.hideCursor());
        };
  
        // Product display navs
        scope.querySelectorAll('.mt-product-display__nav-button--prev').forEach((btn) => {
          bindOnce(btn, 'left');
        });
        scope.querySelectorAll('.mt-product-display__nav-button--next').forEach((btn) => {
          bindOnce(btn, 'right');
        });
  
        // Womo banner navs
        scope.querySelectorAll('.mt-womo-banner__nav--prev').forEach((btn) => {
          bindOnce(btn, 'left');
        });
        scope.querySelectorAll('.mt-womo-banner__nav--next').forEach((btn) => {
          bindOnce(btn, 'right');
        });
  
        // Womo category navs
        scope.querySelectorAll('.mt-womo-category__nav-btn--prev').forEach((btn) => {
          bindOnce(btn, 'left');
        });
        scope.querySelectorAll('.mt-womo-category__nav-btn--next').forEach((btn) => {
          bindOnce(btn, 'right');
        });
         // GF pagination arrows (Globo SPF)
      scope.querySelectorAll('#gf_pagination_wrap .pagination span.prev > a.gspf-page').forEach((btn) => {
        bindOnce(btn, 'left');
      });
      scope.querySelectorAll('#gf_pagination_wrap .pagination span.next > a.gspf-page').forEach((btn) => {
        bindOnce(btn, 'right');
      });
  
        //swiper
        scope.querySelectorAll('.mt-swiper-prev').forEach((btn) => {
          bindOnce(btn, 'left');
        });
        scope.querySelectorAll('.mt-swiper-next').forEach((btn) => {
          bindOnce(btn, 'right');
        });
  
        //product-list
        scope.querySelectorAll('.mt-review-slider__arrow--prev').forEach((btn) => {
          bindOnce(btn, 'left');
        });
        scope.querySelectorAll('.mt-review-slider__arrow--next').forEach((btn) => {
          bindOnce(btn, 'right');
        });

        // model
        scope.querySelectorAll('.mt-modal-nav-left').forEach((btn) => {
          bindOnce(btn, 'left');
        });
        scope.querySelectorAll('.mt-modal-nav-right').forEach((btn) => {
          bindOnce(btn, 'right');
        });
  
        //product
        scope.querySelectorAll('.mt-cursor-nav-left-black').forEach((btn) => {
          bindOnce(btn, 'up');
        });
        scope.querySelectorAll('.mt-cursor-nav-right-black').forEach((btn) => {
          bindOnce(btn, 'down');
        });

        //close
        scope.querySelectorAll('.mt-close-black').forEach((btn) => {
          bindOnce(btn, 'close');
        });
   

        // Womo banner drag zones（左右 100px 拖拽按钮区域，展示双向箭头光标）
        scope.querySelectorAll('.mt-womo-banner__drag-zone--left').forEach((zone) => {
          bindOnce(zone, 'drag');
        });
        scope.querySelectorAll('.mt-womo-banner__drag-zone--right').forEach((zone) => {
          bindOnce(zone, 'drag');
        });
      }
  
      showCursor(type) {
        this.isActive = true;
        this.updateCursorIcon(type);
        this.cursor.classList.add('active');
      }
  
      hideCursor() {
        this.isActive = false;
        this.cursor.classList.remove('active');
      }
  
      updateCursorIcon(type) {
        // Remove all icon classes
        this.cursor.classList.remove('show-circle', 'show-left', 'show-right', 'show-drag','show-up','show-down','show-close');
        
        // Add appropriate class
        if (type === 'circle') {
          this.cursor.classList.add('show-circle');
        } else if (type === 'left') {
          this.cursor.classList.add('show-left');
        } else if (type === 'right') {
          this.cursor.classList.add('show-right');
        } else if (type === 'drag') {
          this.cursor.classList.add('show-drag');
        } else if (type === 'up') {
          this.cursor.classList.add('show-up');
        } else if (type === 'down') {
          this.cursor.classList.add('show-down');
        }else if (type === 'close') {
          this.cursor.classList.add('show-close');
        }
      }
  
      updateCursorPosition(e) {
        this.targetX = e.clientX;
        this.targetY = e.clientY;
        // 首次收到鼠标坐标时直接跳到目标位置，避免从 (0,0) 漂移到鼠标处
        if (!this.initialized) {
          this.currentX = this.targetX;
          this.currentY = this.targetY;
          this.initialized = true;
        }
      }
  
      animate() {
        // 只有收到过鼠标坐标后才更新位置，避免首帧渲染在 (0,0)
        if (this.initialized) {
          this.currentX += (this.targetX - this.currentX) * this.ease;
          this.currentY += (this.targetY - this.currentY) * this.ease;
          this.cursor.style.left = `${this.currentX}px`;
          this.cursor.style.top = `${this.currentY}px`;
        }
        this.animationFrame = requestAnimationFrame(() => this.animate());
      }
    }
  
    // Global cursor manager instance
    let cursorManager = null;
  
    // Initialize cursor manager and register all product display sections
    function initProductDisplayCursors() {
      // Create cursor manager if it doesn't exist
      if (!cursorManager) {
        cursorManager = new ProductDisplayCursorManager();
      }
      
      // Register all sections
      const sections = document.querySelectorAll('.mt-product-display');
      sections.forEach(section => {
        cursorManager.registerSection(section);
      });
  
      // Register all navigation buttons (product display + womo banner + womo category)
      cursorManager.registerNavButtons(document);
    }
  
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductDisplayCursors);
    } else {
      initProductDisplayCursors();
    }
  
    // Handle Shopify theme editor
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        // 只要相关区块被加载，就重新注册一次（内部会通过 data 标记避免重复绑定）
        if (
          event.target.querySelector('.mt-product-display') ||
          event.target.querySelector('.mt-womo-banner') ||
          event.target.querySelector('.mt-womo-category') ||
          event.target.querySelector('.mt-custom-product-container')
        ) {
          initProductDisplayCursors();
        }
      });
    }
  // GF/搜索筛选等 AJAX 渲染：新增节点后补绑分页箭头等 hover 光标
  const observer = new MutationObserver((mutations) => {
    if (!cursorManager) return;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node && node.nodeType === 1) {
          cursorManager.registerNavButtons(node);
          if (node.matches && node.matches('.mt-product-display')) {
            cursorManager.registerSection(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('.mt-product-display').forEach((section) => {
              cursorManager.registerSection(section);
            });
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

  